import { AxiosResponse, AxiosError } from "axios";

export type Response = {
  data: any | null;
  error: ErrorResponse | null;
};

export type ErrorResponse = {
  status: number;
  data: { id: string; message: string }[];
};

// 正常レスポンスを返す
export const parseResponse = (response: AxiosResponse<any>) => {
  return { data: response.data, error: null } as Response;
};

// エラーレスポンスを返す
export const parseError = (error: AxiosError) => {
  return {
    data: null,
    error: {
      status: error.response?.status || 500,
      data: error.response?.data || [],
    },
  } as Response;
};
